import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1deb82df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-solution-first-block-wrap" }
const _hoisted_2 = { class: "terminal-solution-first-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "terminal-solution-first-block-text margin-l-r" }, " Check back often for new content, and sign up for our newsletter to receive updates directly to your inbox. ", -1))

import {TabInteractiveBlock} from "@/features";
import {onBeforeMount, ref} from "vue";
import {
  cash_in_cash_out,
  creditomat_terminal,
  cryptomat_terminal,
  edc,
  pos_terminals,
  shopping_cart,
  HelpModel,
  useLocalizationStore,
} from "@/shared";
import {WrapTitle} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-solution-content-menu-block',
  setup(__props) {

const {translate} = useLocalizationStore();

onBeforeMount(() => {
  initArrData();
});

const arrData = ref<Array<HelpModel>>(new Array<HelpModel>());

const initArrData = () => {
  arrData.value.push(new HelpModel({
    Text: "cash_in_cash_out_terminals",
    Image: cash_in_cash_out,
    ScrollHash: "#cash"
  }));//4
  arrData.value.push(new HelpModel({
    Text: "pos_terminals",
    Image: pos_terminals,
    ScrollHash: "#pos"
  }));//1
  arrData.value.push(new HelpModel({
    Text: "cryptomat",
    Image: cryptomat_terminal,
    ScrollHash: "#cryptomat"
  }));//2
  arrData.value.push(new HelpModel({
    Text: "creditomat",
    Image: creditomat_terminal,
    ScrollHash: "#creditomat"
  }));//5
  arrData.value.push(new HelpModel({
    Text: "self_service_terminals",
    Image: edc,
    ScrollHash: "#selfservice"
  }));//3
  arrData.value.push(new HelpModel({
    Text: "android_app",
    Image: shopping_cart,
    ScrollHash: "#androidapp"
  }));//6
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(WrapTitle), {
        text: _unref(translate)('terminal_solutions_page_title'),
        class: "terminal-solution-first-block-title margin-l-r",
        size: "regular",
        weight: "700"
      }, null, 8, ["text"]),
      _createVNode(_unref(TabInteractiveBlock), {
        arrData: arrData.value,
        class: "terminal-solution-first-block-tab first",
        color: "white"
      }, null, 8, ["arrData"]),
      _hoisted_3
    ])
  ]))
}
}

})